// extracted by mini-css-extract-plugin
export default {"certificateTitle":"delete_certificate_modal-module___certificateTitle___a1943866"};